// src/services/announcementService.js

import axiosInstance from "../api/axiosInstance";

/**
 * Dev logger (hidden in production)
 */
const devLog = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    console.log("[announcementService]", ...args);
  }
};

/**
 * Common request handler
 */
const handleRequest = async (requestFn) => {

  try {

    devLog("API request started");

    const response = await requestFn();

    devLog("API success:", response);

    return {
      success: true,
      data: response.data,
      status: response.status
    };

  } catch (error) {

    devLog("API error:", error);

    return {
      success: false,
      data: null,
      status: error?.response?.status,
      message:
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong"
    };

  }

};


/* ===============================
   PUBLIC ANNOUNCEMENTS
================================ */

/**
 * Fetch active announcements
 */
export const fetchActiveAnnouncements = () =>
  handleRequest(() =>
    axiosInstance.get("/announcements/active")
  );
